import Marquee from "react-fast-marquee";

const ITEMS = [
  "Full-time Syncro 4WD",
  "2.1L Waterboxer",
  "Tin top",
  "Rooftop tent",
  "Expedition racks",
  "Rear diff lock",
  "Granny first gear",
  "One careful keeper",
];

export default function MarqueeRibbon() {
  return (
    <div className="border-y border-border bg-muted py-4 md:py-5 overflow-hidden" data-testid="marquee-ribbon">
      <Marquee speed={28} gradient={false}>
        {ITEMS.map((item) => (
          <span
            key={item}
            className="font-mono text-sm md:text-base uppercase tracking-[0.3em] text-foreground/70 mx-6 whitespace-nowrap"
          >
            {item} <span className="text-primary ml-12">✶</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
